module.exports = __webpack_public_path__ + "img/shoplogo.5dba109d.svg";